import type { NudgeData } from "./NudgeData.js";
import { NudgeCheckResult } from "./NudgeCheckResult.js";

const TWENTY_HOURS_MS = 20 * 60 * 60 * 1000;

function hasUTCDayChanged(lastDate: Date | null): boolean {
    if (lastDate === null)
        return true;

    const now = new Date();
    return lastDate.getUTCDate() !== now.getUTCDate()
        || lastDate.getUTCMonth() !== now.getUTCMonth()
        || lastDate.getUTCFullYear() !== now.getUTCFullYear();
}

export function checkSuggestPandaBotNudge(nudge: NudgeData): NudgeCheckResult {
    // Show if UTC day changed and user previously accepted
    if (hasUTCDayChanged(nudge.getLastConsideredDate()) && nudge.getConsecutiveAccepts() > 0)
        return NudgeCheckResult.SHOW;

    // Not considered if we checked it in the last 20 hours
    if (nudge.getTimeSinceLastConsideredMs() < TWENTY_HOURS_MS)
        return NudgeCheckResult.NOT_CONSIDERED;

    // Show if user previously accepted
    if (nudge.getConsecutiveAccepts() > 0)
        return NudgeCheckResult.SHOW;

    if (nudge.getConsecutiveDeclines() === 0) {
        // Show if we have skipped at least once with no declines
        if (nudge.getSkipsSinceLastShown() > 0)
            return NudgeCheckResult.SHOW;

    } else {
        // Require a few skips before showing again after a decline
        const requiredSkips = Math.min(nudge.getConsecutiveDeclines() + 1, 4);
        if (nudge.getConsecutiveDeclines() > 0 && nudge.getSkipsSinceLastShown() >= requiredSkips)
            return NudgeCheckResult.SHOW;
    }
    return NudgeCheckResult.SKIP;
}
